import {useAtom} from 'jotai'

import {
  listAtom,
  listFilterAtom,
  listFilterTrxAtom,
  listFilterMarketingAtom,
  memberDetailAtom,
  memberDetailTabAtom,
  tabNameAtom,
} from '../store'

export const useMember = () => {
  const [list, listSet] = useAtom(listAtom)
  const [listFilter, listFilterSet] = useAtom(listFilterAtom)
  const [listFilterTrx, listFilterSetTrx] = useAtom(listFilterTrxAtom)
  const [listFilterMarketing, listFilterSetMarketing] = useAtom(listFilterMarketingAtom)

  const [tabName, tabNameSet] = useAtom(tabNameAtom)

  const [detail, detailSet] = useAtom(memberDetailAtom)
  const [detailTab, detailTabSet] = useAtom(memberDetailTabAtom)

  const updateDetail = (
    data: any,
    type:
      | 'Segment'
      | 'Address'
      | 'Consent'
      | 'Transaction'
      | 'Engagement'
      | 'SmsEngagement'
      | 'PushEngagement'
      | 'EmailEngagement'
  ) => {
    detailTabSet((prev) => {
      // if (!prev) return null

      return {
        ...prev,
        [type]: data,
      }
    })
  }

  return {
    list,
    listSet,
    detail,
    detailSet,
    tabName,
    tabNameSet,
    detailTab,
    detailTabSet,
    updateDetail,
    listFilter,
    listFilterSet,
    listFilterTrx,
    listFilterSetTrx,
    listFilterMarketing,
    listFilterSetMarketing,
  }
}
